import { render, staticRenderFns } from "./ImportSection.vue?vue&type=template&id=06967bd6&"
import script from "./ImportSection.vue?vue&type=script&lang=ts&"
export * from "./ImportSection.vue?vue&type=script&lang=ts&"
import style0 from "./ImportSection.vue?vue&type=style&index=0&id=06967bd6&prod&module=true&lang=scss&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports
import {QCardSection,QIcon} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCardSection,QIcon})
